<template>
  <div id="admin-overview-index" v-loading="loading">
    <!-- 后台概览界面 -->
    <div class="left">
      <div class="icon">
        <div class="ii">
          <img :src="userData.icon" alt="" />
          <div class="choose">
            <el-upload
              class="upload-demo"
              :action="action"
              :headers="headers"
              :show-file-list="false"
              multiple
              :data="{
                title: '用户头像',
              }"
              :before-upload="beforeAvatarUpload"
              :on-success="handleAvatarSuccess"
            >
              <div class="mb">选择文件</div>
            </el-upload>
          </div>
        </div>
      </div>
      <div class="line">{{ userData.name }}</div>
      <div class="line">职业技能等级:{{ userData.leverl }}</div>
      <div class="line">学历:{{ userData.education }}</div>
      <div class="line">入伍年月:{{ userData.armyDate }}</div>
      <!-- <div class="line"><div class="title-but">个人中心</div></div> -->
    </div>
    <div class="content">
      <div class="top">
        <div class="img">
          <img src="../../../assets/img/onlinetest.png" alt="" />
        </div>
        <div class="title">{{ examTitle }}</div>
        <div class="time">考试时间: {{ examTme }}</div>
        <div class="but">
          <div class="add_but" @click="gotoDetails">查看详情</div>
        </div>
      </div>
      <div class="blow">
        <div class="title">
          <div class="tip"></div>
          考试列表
          <div class="perch-active"></div>
          <div class="title-but" @click="goto('exam')">
            <i class="el-icon-more"></i>
          </div>
        </div>
        <div class="table">
          <el-table :data="examTable" stripe style="width: 100%" height="100%">
            <el-table-column
              prop="name"
              label="主题"
              width="230"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column prop="time" label="考试时间" show-overflow-tooltip>
            </el-table-column>
            <el-table-column
              prop="department"
              label="考试部门"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="status"
              label="考试状态"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="professional"
              label="考试专业"
              show-overflow-tooltip
            >
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <div class="right">
      <div class="r-top">
        <div class="title">
          <div class="tip"></div>
          部门管理
          <div class="perch-active"></div>
          <div class="title-but" @click="goto('department')">
            <i class="el-icon-more"></i>
          </div>
        </div>
        <div class="table">
          <el-tree
            :data="departmentTree"
            :props="defaultProps"
            default-expand-all
          >
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <i class="iconfont icon-24gf-folderOpen" v-if="!node.isLeaf"></i>
              <i v-else class="iconfont icon-24gf-fileText"></i>
              <span
                >{{ node.label }}（{{ data.leaderNum }} /
                {{ data.userNum }}人）</span
              >
              <span class="perch-active"></span>
            </span>
          </el-tree>
        </div>
      </div>
      <div class="r-below">
        <div class="title">
          <div class="tip"></div>
          {{ type }}
          <div class="perch-active"></div>
          <div class="title-but">
            <el-dropdown>
              <i class="el-icon-more"></i>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <span @click="changeType(0)">上岗证到期</span>
                </el-dropdown-item>
                <el-dropdown-item>
                  <span @click="changeType(1)">初次到岗考核</span>
                </el-dropdown-item>
                <el-dropdown-item>
                  <span @click="changeType(2)">复岗考核</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <div class="table">
          <el-table
            :data="userTable1"
            stripe
            style="width: 100%"
            height="100%"
            v-if="flag == 0"
          >
            <el-table-column
              prop="userName"
              label="姓名"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="number"
              label="上岗证编号"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="becomeTime"
              label="到期时间"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
          </el-table>
          <el-table
            :data="userTable2"
            stripe
            style="width: 100%"
            height="100%"
            v-if="flag == 1"
          >
            <el-table-column
              prop="name"
              label="姓名"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="department"
              label="部门"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="firstCome"
              label="初次到岗时间"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="comeDay"
              label="到岗天数"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
          </el-table>
          <el-table
            :data="userTable3"
            stripe
            style="width: 100%"
            height="100%"
            v-if="flag == 2"
          >
            <el-table-column
              prop="name"
              label="姓名"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="department"
              label="部门"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="meltTime"
              label="复岗时间"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="meltDay"
              label="复岗天数"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      examTitle: "",
      examTme: "",
      exaId: "",
      examTable: [],
      userTable1: [],
      userTable2: [],
      userTable3: [],
      departmentTree: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
      userData: {},
      type: "上岗证到期",
      flag: 0,
      action: this.$baseurl + "/uploadFile",
      headers: {
        token: "",
      },
    };
  },
  methods: {
    async getUserDetails() {
      try {
        let userData = JSON.parse(sessionStorage.getItem("userData"));
        let resultData = await this.$request({
          url: "/user/getUserDetails",
          method: "post",
          data: { id: userData.userId },
        });
        this.userData = resultData;
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    async getAllTestList() {
      try {
        let requestData = {
          status: "",
          name: "",
          time: ["", ""],
          pageSize: 100,
          currentPage: 1,
        };
        let resultData = await this.$request({
          url: "/exam/getAllTestList",
          method: "post",
          data: requestData,
        });
        this.examTable = resultData.tableData;
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    async getDepartmentTree() {
      try {
        let resultData = await this.$request({
          url: "/department/getDepartmentTree",
          method: "post",
          data: {},
        });
        this.departmentTree = [resultData];
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    async getRecentlyExam() {
      try {
        let resultData = await this.$request({
          url: "/exam/getRecentlyExam",
          method: "post",
          data: { uId: "" },
        });
        if (resultData.id != "") {
          this.examTitle = resultData.name;
          this.examTme = resultData.time;
        } else {
          this.examTitle = "暂无考试计划!";
          this.examTme = "";
        }
      } catch (error) {
        this.$message({
          message: error.message,
          type: "warning",
          duration: 1000,
        });
      }
    },
    async changeType(key) {
      try {
        this.flag = key;
        let resultData = {};
        switch (key) {
          case 0:
            // 获取上岗证到期数据
            this.type = "上岗证到期";
            resultData = await this.$request({
              url: "/statistics/expireWorkUser",
              method: "post",
              data: {},
            });
            this.type += "（" + resultData.num + "人）";
            this.userTable1 = resultData.tableData;
            break;
          case 1:
            // 获取需要参加初次到岗考核数据
            this.type = "初次到岗考核";
            resultData = await this.$request({
              url: "/statistics/needFirst",
              method: "post",
              data: {},
            });
            this.type += "（" + resultData.num + "人）";
            this.userTable2 = resultData.tableData;
            break;
          case 2:
            // 获取需要参加复岗考核数据
            this.type = "复岗考核";
            resultData = await this.$request({
              url: "/statistics/needAgain",
              method: "post",
              data: {},
            });
            this.type += "（" + resultData.num + "人）";
            this.userTable3 = resultData.tableData;
            break;

          default:
            break;
        }
        this.$forceUpdate();
      } catch (error) {
        this.$message({
          message: error.message,
          type: "warning",
          duration: 1000,
        });
      }
    },
    goto(active) {
      let path = "/admin/";
      let fatherMenu = sessionStorage.getItem("fatherMenu");
      let subMenu = sessionStorage.getItem("subMenu");
      switch (active) {
        case "exam":
          path += "exam-index/list";
          fatherMenu = "exam-index";
          subMenu = "list";
          break;
        case "user":
          path += "system-index/person";
          fatherMenu = "system-index";
          subMenu = "person";
          break;
        case "department":
          path += "system-index/department";
          fatherMenu = "system-index";
          subMenu = "department";
          break;

        default:
          break;
      }
      sessionStorage.setItem("fatherMenu", fatherMenu);
      sessionStorage.setItem("subMenu", subMenu);
      this.$router.push(path);
    },
    /**
     * 导入前文件格式判断  只能上传exel格式数据
     */
    beforeAvatarUpload(file) {
      console.log(file.type);
      let isJPG = false;
      let errorString = "";
      isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/jpg" ||
        file.type === "image/png";
      errorString = "图像仅支持.png、.jpg、.jpeg格式!!!";

      if (!isJPG) {
        this.$message.error(errorString);
      }
      return isJPG;
    },
    /**
     * 模板上传成功
     */
    async handleAvatarSuccess(response, file, fileList) {
      console.log(response);
      try {
        if (response.code == "200") {
          let requestData = {
            id: JSON.parse(sessionStorage.getItem("userData")).userId,
            icon: response.result.path,
          };
          let resultData = await this.$request({
            url: "/user/updateIcon",
            method: "post",
            data: requestData,
          });
          this.$message.success("图像上传成功!");
          this.userData.icon = response.result.path;
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },

    // 跳转至考试中心
    gotoDetails() {
      this.$router.push("/admin/exam-index/list");
    },
  },
  async mounted() {
    this.loading = true;
    await this.getUserDetails();
    await this.getAllTestList();
    await this.getDepartmentTree();
    await this.getRecentlyExam();
    await this.changeType(0);
    setTimeout(() => {
      this.loading = false;
    }, 300);
  },
};
</script>

<style lang="less" scoped>
#admin-overview-index {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  > .left {
    width: 15%;
    height: auto;
    background-color: #fcfcfc;
    display: flex;
    flex-direction: column;
    > .icon {
      width: 100%;
      height: 120px;
      margin-bottom: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      > .ii {
        width: 80px;
        height: 80px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        img {
          width: 80px;
          height: 80px;
          border-radius: 50%;
        }
        .choose {
          opacity: 0;
          position: absolute;
          width: 100%;
          top: 0;
          left: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: 0.3s;
          .mb {
            width: 80px;
            height: 80px;
            border-radius: 50%;
            background-color: #00000054;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 13px;
          }
        }
        &:hover .choose {
          opacity: 1;
        }
      }
    }
    > .line {
      width: 100%;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      > .title-but {
        width: auto;
        font-size: 13px;
        border: 1px solid #333;
        font-weight: normal;
        padding: 4px 19px;
        box-sizing: border-box;
        border-radius: 3px;
        cursor: pointer;
      }
    }
  }
  > .content {
    height: auto;
    width: 40%;
    margin-left: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    > .top {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      background-color: #fcfcfc;
      padding-bottom: 100px;
      box-sizing: border-box;
      > .img {
        width: 100%;
        height: 200px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      > .title {
        width: 100%;
        height: auto;
        display: flex;
        font-size: 20px;
        align-items: center;
        justify-content: center;
        font-weight: bold;
      }
      > .time {
        width: 100%;
        height: auto;
        display: flex;
        font-size: 17px;
        align-items: center;
        justify-content: center;
        margin-top: 20px;
      }
      > .but {
        width: 40%;
        margin-top: 20px;
      }
    }
    > .blow {
      width: 100%;
      margin-top: 10px;
      height: 0;
      flex: 1;
      background-color: #fcfcfc;
      display: flex;
      flex-direction: column;
    }
  }
  > .right {
    width: 25%;
    height: auto;
    margin-left: 20px;
    display: flex;
    flex-direction: column;
    > .r-top,
    > .r-below {
      width: 100%;
      height: 0;
      flex: 1;
      background-color: #fcfcfc;
      display: flex;
      flex-direction: column;
    }
    > .r-top {
      margin-bottom: 10px;
    }
  }
  .title {
    width: 100%;
    height: 40px;
    display: flex;
    padding: 0 20px;
    box-sizing: border-box;
    align-items: center;
    font-size: 15px;
    font-weight: bold;
    > .tip {
      width: 3px;
      height: 15px;
      background-color: @baseColor;
      margin-right: 10px;
    }
    > .title-but {
      width: auto;
      font-size: 13px;
      // border: 1px solid #333;
      font-weight: normal;
      padding: 2px 12px;
      box-sizing: border-box;
      // border-radius: 3px;
      cursor: pointer;
    }
  }
  .table {
    width: 100%;
    height: 0;
    flex: 1;
    display: flex;
    padding: 10px;
    box-sizing: border-box;
    overflow-y: auto;
  }
  /deep/ .el-tree {
    width: 100%;
  }
  /deep/ .el-tree-node__content {
    margin-bottom: 10px;
    font-size: 14px;
  }
  /deep/ .iconfont {
    margin-right: 5px;
  }
}
</style>